import { HTMLAttributes } from 'react'
import { Container, TabsContainer, TabControls } from './styles'
import { TabItem } from './types'

type Props<T extends string> = {
  activeTab?: T
  items: TabItem<T>[]
  onTabChange: (tab: T) => void
} & HTMLAttributes<HTMLDivElement>

export const TabLayout = <T extends string>(props: Props<T>) => {
  const { activeTab, onTabChange, items, ...rest } = props

  const onTabClick = (tab: T) => {
    if (tab !== activeTab) {
      onTabChange(tab)
    }
  }

  return (
    <Container {...rest}>
      <TabsContainer>
        {items.map(item => (
          <TabControls
            key={item.id}
            onClick={() => onTabClick(item.id)}
            isActive={activeTab === item.id}
          >
            <span>{item.text}</span>
          </TabControls>
        ))}
      </TabsContainer>
    </Container>
  )
}
